module.exports = __webpack_public_path__ + "static/media/Fronius.1ebe0af8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Fronius.jpg
// module id = 1106
// module chunks = 0